// src/components/packages/Table/PackagesTableColumns.jsx

const PackagesTableColumns = [
    { id: "name_ar", labelAr: "الاسم (عربي)", labelEn: "Name (Arabic)", sortable: true },
    { id: "name_en", labelAr: "الاسم (إنجليزي)", labelEn: "Name (English)", sortable: true },
    { id: "status", labelAr: "الحالة", labelEn: "Status", sortable: false },
];

export default PackagesTableColumns;
